<template>
  <div class="invoice-over-view">
    <over-view-top-line :topData="overViewTopData" />

    <div class="finance-over-view-line">
      <h2>开票金额</h2>
      <chart-time-select @getData="getInvoicingMoney" style="right: 0.14rem;top: 7.5%"/>
      <common-line
        style="z-index: 1000"
        lineId='invoiceAccessRecordLine'
        legendRight="478px"
        legendTop="2.7%"
        gridLeft="1.7%"
        :height='"1.73rem"'
        :legendTextStyle="legendTextStyle"
        :legendData="invoiceAccessRecordLegendData"
        :xAxis="invoiceAccessRecordXAxis"
        :yAxis='invoiceAccessRecordYAxis'
        :series='invoiceAccessRecordSeries'
      />
    </div>

    <div class="finance-over-view-line" style="margin-bottom: 0">
      <h2>开票次数</h2>
      <chart-time-select @getData="getInvoicingCount" style="right: 0.14rem;top: 7.5%"/>
      <common-line
        style="z-index: 1000"
        lineId='invoiceCountLine'
        legendRight="478px"
        legendTop="2.7%"
        gridLeft="1.7%"
        :height='"1.73rem"'
        :legendTextStyle="legendTextStyle"
        :legendData="invoiceCountLegendData"
        :xAxis="invoiceCountXAxis"
        :yAxis='invoiceCountYAxis'
        :series='invoiceCountSeries'
      />
    </div>

  </div>

</template>

<script>
import CommonRing from '../../../components/Echarts/Pie/Pie/commonRing'
import {api} from '../../api/invoice'
import {errorHandler} from '../../../utils/errorHandler'
import CommonLine from '../../../components/Echarts/Line/commonLine'
import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/newChartTimeSelect";
import OverViewTopLine from "../../../components/OverView/newOverViewTopLine";
import {iconListChoose} from "../../../utils/icon";
import {debounce} from "../../../utils/util";

export default {
  components: {
    OverViewTopLine,
    ChartTimeSelect,
    CommonLine,
    CommonRing},
  name: 'invoice-over-view',
  data () {
    return {
      overViewTopData: [
        [
          {
            code1: 'total',
            code2: 'invoiceCount',
            name: '总开票次数',
            value: "0",
            unit: "次",
            color: "#fff",
            background: "linear-gradient(to right, rgba(52, 147, 235, .8), rgba(54, 212, 233, .8))",
            icon: require('../../../assets/smart_invoice/Invoicing_total.png')
          },
          {
            code1: 's',
            code2: 'invoiceCount',
            name: '增值税专票次数',
            value: "0",
            unit: "次",
            color: "#fff",
            background: "linear-gradient(to right, rgba(240, 152, 25, .8), rgba(237, 222, 93, .8))",
            icon: require('../../../assets/smart_invoice/VAT_invoice_num.png')
          },
          {
            code1: 'p',
            code2: 'invoiceCount',
            name: '增值税普票次数',
            value: "0",
            unit: "次",
            color: "#fff",
            background: "linear-gradient(to right, rgba(255, 121, 121, .8), rgba(254, 166, 208, .8))",
            icon: require('../../../assets/smart_invoice/ordinary_invoice_num.png')
          },
          {
            code1: 'receipt',
            code2: 'invoiceCount',
            name: '收据次数',
            value: "0",
            unit: "次",
            color: "#fff",
            background: "linear-gradient(to right, rgba(51, 201, 96, .8), rgba(43, 205, 205, .8))",
            icon: require('../../../assets/smart_invoice/receipt_num.png')
          },
        ],
        [
          {
            code1: 'total',
            code2: 'invoiceMoney',
            name: '总开票金额',
            value: "0",
            unit: "元",
            color: "#fff",
            background: "linear-gradient(to right, rgba(191, 112, 251, .8), rgba(156, 189, 255, .8))",
            icon: require('../../../assets/smart_invoice/Invoice_amount_total.png')
          },
          {
            code1: 's',
            code2: 'invoiceMoney',
            name: '增值税专票金额',
            value: "0",
            unit: "元",
            color: "#fff",
            background: "linear-gradient(to right, rgba(210, 147, 54, .8), rgba(255, 143, 142, .8))",
            icon: require('../../../assets/smart_invoice/VAT_invoice_amount.png')
          },
          {
            code1: 'p',
            code2: 'invoiceMoney',
            name: '增值税普票金额',
            value: "0",
            unit: "元",
            color: "#fff",
            background: "linear-gradient(to right, rgba(236, 104, 144, .8), rgba(161, 95, 228, .8))",
            icon: require('../../../assets/smart_invoice/ordinary_invoice_amount.png')
          },
          {
            code1: 'receipt',
            code2: 'invoiceMoney',
            name: '收据金额',
            value: "0",
            unit: "元",
            color: "#fff",
            background: "linear-gradient(to right, rgba(83, 107, 248, .8), rgba(38, 208, 206, .8))",
            icon: require('../../../assets/smart_invoice/receipt_amount.png')
          }
        ]
      ],
      invoiceColorList: ['#5B9BD5', '#ED7D31', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC', '#47C4CA', '#77E5BF', '#82D74C', '#A4C344'],
      invoiceRingLegend: {
        left: 'center',
        bottom: -5,
      },

      invoiceMoney: 0,
      invoiceCount: 0,

      invoiceAccessRecordTitle: '开票金额',
      invoiceAccessRecordLegendData: ['总金额', '专票金额', '普票金额', '收据金额'],
      invoiceAccessRecordXAxis: {
        type: 'category',
        name: '日期',
        nameTextStyle: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        boundaryGap: false,
        axisTick: {
          show: false, //是否显示刻度
        },
        axisLabel: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'dotted',
            color: 'rgba(50,50,50,0.4)',//坐标线的颜色
          }
        },
        data: []
      },
      invoiceAccessRecordYAxis: [
        {
          type: 'value',
          name: '金额(元)',
          nameTextStyle: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisTick: {
            show: false, //是否显示刻度
          },
          axisLabel: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)',//坐标线的颜色
            }
          },
        }
      ],
      invoiceAccessRecordSeries: [],
      legendTextStyle: {
        fontSize: 'calc(100vw * 14/ 1920)',
      },


      invoiceCountTitle: '开票次数',
      invoiceCountLegendData: ['总次数', '专票次数', '普票次数', '收据次数'],
      invoiceCountXAxis: {
        type: 'category',
        name: '日期',
        nameTextStyle: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        boundaryGap: false,
        axisTick: {
          show: false, //是否显示刻度
        },
        axisLabel: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'dotted',
            color: 'rgba(50,50,50,0.4)',//坐标线的颜色
          }
        },
        data: []
      },
      invoiceCountYAxis: [
        {
          type: 'value',
          name: '次数',
          nameTextStyle: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisTick: {
            show: false, //是否显示刻度
          },
          axisLabel: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)',//坐标线的颜色
            }
          },
        }
      ],
      invoiceCountSeries: [],
      idList: ['invoiceAccessRecordLine', 'invoiceCountLine']
    }
  },
  mounted () {
    this.getStatistics()
    window.addEventListener('resize', this.resizeChart)
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeChart)
  },
  methods: {
    resizeChart: debounce(function () {
      this.idList.map(v => {
        let commonLine = this.$echarts.init(document.getElementById(v));
        commonLine.resize()
      })
    }, 100),
    getStatistics () {
      this.$axios.get(api.getStatistics, {})
        .then(res => {
          let data = res.data.data
          // this.invoiceMoney = data.invoiceMoney;
          // this.invoiceCount = data.invoiceCount;
          this.overViewTopData.map(f => {
            f.map(v => {
              v.value = data[v.code1][v.code2]
            })
          })
        })
        .catch(errorHandler('获取数据失败'))
    },

    getInvoicingMoney (type, startTime, endTime) {
      this.$axios.post(`${api.getInvoicingMoney}`, {
        startTime: startTime || '',
        endTime: endTime || '',
        timeType: type || 'DAY'
      })
        .then(res => {
          let data = res.data.data
          let xData = []
          let seriesData1 = [], seriesData2 = [],seriesData3 = [],seriesData4 = []
          data.map(v => {
            seriesData1.push(v.totalInvoicingMoney)
            seriesData2.push(v.sinvoicingMoney)
            seriesData3.push(v.pinvoicingMoney)
            seriesData4.push(v.receiptMoney)
            if (type === 1) {
              let dateArr = v.time.split('-')
              let showData = `${dateArr[1]}-${dateArr[2]}`
              xData.push(showData)
            } else {
              xData.push(v.time)
            }
          })
          this.invoiceAccessRecordXAxis.data = xData
          this.invoiceAccessRecordSeries = [
            {
              name: '总金额',
              type: 'line',
              stack: '总金额',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#0A84FF'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(10, 132, 255, 0.40)'
                }, {
                  offset: 1,
                  color: 'rgba(10, 132, 255, 0)'
                }])
              },
              data: seriesData1
            },
            {
              name: '专票金额',
              type: 'line',
              stack: '专票金额',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#32D74B'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(50, 215, 75, 0.40)'
                }, {
                  offset: 1,
                  color: 'rgba(50, 215, 75, 0)'
                }])
              },
              data: seriesData2
            },
            {
              name: '普票金额',
              type: 'line',
              stack: '普票金额',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#8438FF'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(132, 56, 255, 0.40)'
                }, {
                  offset: 1,
                  color: 'rgba(132, 56, 255, 0)'
                }])
              },
              data: seriesData3
            },
            {
              name: '收据金额',
              type: 'line',
              stack: '收据金额',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#FF8C38'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(255, 140, 56, 0.40)'
                }, {
                  offset: 1,
                  color: 'rgba(255, 140, 56, 0)'
                }])
              },
              data: seriesData4
            },
          ]
        })
        .catch(errorHandler('获取数据失败'))
    },

    getInvoicingCount (type, startTime, endTime) {
      this.$axios.post(`${api.getInvoicingCount}`, {
        startTime: startTime || '',
        endTime: endTime || '',
        timeType: type || 'DAY'
      })
        .then(res => {
          let data = res.data.data
          let xData = []
          let seriesData1 = [], seriesData2 = [],seriesData3 = [],seriesData4 = []
          data.map(v => {
            seriesData1.push(v.totalInvoicingNumber)
            seriesData2.push(v.sinvoicingNumber)
            seriesData3.push(v.pinvoicingNumber)
            seriesData4.push(v.receiptNumber)
            if (type === 1) {
              let dateArr = v.time.split('-')
              let showData = `${dateArr[1]}-${dateArr[2]}`
              xData.push(showData)
            } else {
              xData.push(v.time)
            }
          })
          this.invoiceCountXAxis.data = xData
          this.invoiceCountSeries = [
            {
              name: '总次数',
              type: 'line',
              stack: '总次数',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#0A84FF'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(10, 132, 255, 0.40)'
                }, {
                  offset: 1,
                  color: 'rgba(10, 132, 255, 0)'
                }])
              },
              data: seriesData1
            },
            {
              name: '专票次数',
              type: 'line',
              stack: '专票次数',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#32D74B'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(50, 215, 75, 0.40)'
                }, {
                  offset: 1,
                  color: 'rgba(50, 215, 75, 0)'
                }])
              },
              data: seriesData2
            },
            {
              name: '普票次数',
              type: 'line',
              stack: '普票次数',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#8438FF'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(132, 56, 255, 0.40)'
                }, {
                  offset: 1,
                  color: 'rgba(132, 56, 255, 0)'
                }])
              },
              data: seriesData3
            },
            {
              name: '收据次数',
              type: 'line',
              stack: '收据次数',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#FF8C38'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(255, 140, 56, 0.40)'
                }, {
                  offset: 1,
                  color: 'rgba(255, 140, 56, 0)'
                }])
              },
              data: seriesData4
            },
          ]
        })
        .catch(errorHandler('获取数据失败'))
    },

  },
  watch: {}

}
</script>


<style lang="less" scoped>
.invoice-over-view {
  padding: 0.16rem 0.12rem 0.16rem 0.16rem;
  background-color: rgba(240, 240, 247, 1);
  margin: 0;
  h2 {
    position: absolute;
    top: 6.2%;
    font-size: 0.1rem;
    text-align: left;
    z-index: 1001;
  }
  .invoice-over-view-line {
    display: flex;
    justify-content: space-between;
    .invoice-person-count-box {
      width: 400px;
      height: 160px;
      padding: 10px 10px;
      border-radius: 10px;
      color: #ffffff;
      background-color: #00A0E6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #DCDFE6;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
      i {
        width: 30%;
        font-size: 48px;
      }
      .invoice-person-count-box-info {
        width: 70%;
        text-align: left;
        .invoice-person-count {
          font-size: 36px;
          font-weight: 600;
          word-wrap:break-word;
        }
        .invoice-person-tip {
          font-size: 16px;
        }
      }
    }
    .invoice-over-view-line-left {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
    }
    .invoice-over-view-line-right {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      overflow: hidden;
    }

    //.el-table {
    //  thead {
    //    th {
    //      padding: 6px 0;
    //      text-align: center;
    //      color: #666666;
    //      background-color: #eff1f5;
    //    }
    //  }
    //  tbody {
    //    td {
    //      padding: 6px 0;
    //      text-align: center;
    //      color: #FF0000;
    //    }
    //  }
    //}
    //
    //.el-pagination {
    //  padding: 0;
    //}
  }

  .finance-over-view-line {
    margin-bottom: 0.12rem;
    padding: 0.12rem;
    position: relative;
    border-radius: 0.06rem;
    background-color: #fff;
    height: unset;
  }

  /deep/ .chart-time-select {
    margin: 0;
    width: unset;
    left: unset;
  }

  /deep/ .chart-time-select1 {
    margin: 0;
    width: unset;
    left: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Invoice/InvoiceOverView/InvoiceOverView.vue